/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
import Button from "../../../components/Button";
import SettlementsFilter from "./SettlementsFilter";
import { useSelector } from "react-redux";

const SettlementsTopBar = ({
    listLoading,
    requiredAttention,
    setRequiredAttention,
    notFound,
    branchUser,
    ApplyFilter,
    FilterData,
    AddButton,
    Tittle,
    SearchInput,
    AddButtonName,
    SearchValue,
    isClick,
    isFilter,
    FilterCheckbox,
    setFilterCheckBox,
    handleApplyFilter,
    filterCount,
    searchParams,
    BranchDisabled,
    createPath,
    handleFilters,
    handleExport,
    totaldata,
    tooltip,
    searchText,
    sidePane,
    handleSidePopupClick,
    DateRange,
    NoAction,
    testid,
    setsubmitSelected,
    setSearchParams,
    DateRangeError,
    SetDateRangeError,
    productFilter,
    exportloading,
    importloading
}) => {

    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const outSideClick = useRef();
    
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState('');

    const handleYearClick = (e) => {
        setSelectedYear(parseInt(e.target.innerText));
    }

    const handleMonthClick = (e) => {
        setSelectedMonth(e.target.innerText);
    }

    useEffect(() => {
        const params = Object.fromEntries(searchParams);
        if(params.month){
            setSelectedMonth(params.month)
        }
        if(params.year){
            setSelectedYear(params.year)
        }
    },[])

    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false);
    });

    useEffect(() => {
        
    },[])

    const store = JSON.parse(localStorage.getItem('Store'));
    const { List } = useSelector(state => state.Orders);
    const param = Object.fromEntries(searchParams);

    return (
        <>
            <div className="bg-white flex pt-[10px] justify-between items-center px-8 pr-[66px]">
                <div className='pt-8 mb-8 flex justify-between items-center'>
                    <h1 className=' w-full breakword  text-xl font-medium font-playfair text-[#4B4B4B]'>Settlements</h1>
                </div>
                {(List?.data?.length !== 0 || (param.search || param.status || param.payment_type || param.create_start || param.create_end)) && !notFound  && <div className="flex justify-center items-center space-x-10">
                    <div className="relative">
                        <input
                            className="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-[#9E2064] outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                            type="checkbox"
                            id={'settlementsRequiredAttention'}
                            checked={requiredAttention}
                            onClick={() => {
                                setRequiredAttention(prevState => !prevState);
                            }}
                            disabled={listLoading}
                            data-testid="settlements-btn"
                            
                        />
                        <label
                            for={'settlementsRequiredAttention'}
                            className={`inline-block pl-1 hover:cursor-pointer text-base font-normal text-[#1F1F1F] ${listLoading ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        >
                            Settlements that require attention
                        </label>
                    </div>
                    {isFilter && <SettlementsFilter
                        setSelectedYear={setSelectedYear}
                        setSelectedMonth={setSelectedMonth}
                        selectedYear={selectedYear}
                        selectedMonth={selectedMonth}
                        onYearClick={handleYearClick}
                        onMonthClick={handleMonthClick}
                        setIsFilterOpen={setIsFilterOpen}
                        isFilterOpen={isFilterOpen}
                        handleOnClickSearch={handleFilters}
                        DateRange={DateRange}
                        handleApplyFilter={handleApplyFilter}
                        DateRangeError={DateRangeError}
                        productFilter={productFilter}
                        // handleClearFilter={handleClearFilter}
                    />}
                    
                    <Button
                        classKey={`min-w-[73px] font-400 text-[14px] leading-[22px] px-[16px] py-[5px] border border-[#9E2064] text-primary rounded-[12px] relative`} // px-6 py-[8px] rounded-[16px]
                        text="Export"
                        disabled={exportloading}
                        type="button"
                        handleClick={handleExport}
                        testId="export-btn"
                        color="#9E2064"
                        loading={exportloading}
                        smallLoader={true}
                    />
                </div>}
            </div>
        </>
    );
};

export default SettlementsTopBar;
